import { IFeedConfiguration } from 'feed';
import React, { useState } from 'react';
import ParamCss from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/ParamCss';
import HandCategoryButtonParams from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/Tools/Categories/CategoryButton/HandCategoryButtonParams';
import { currentCategoryButtonTextCssParam } from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/Tools/Categories/CategoryButton/currentCategoryButtonTextCssParam';
import { cssSwitchButtons } from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/constants';
import FormItem from '~/components/ui/FormItem';
import SwitchButton from '~/components/ui/SwitchButton';

interface ICategoryButtonProps {
  configuration: IFeedConfiguration;
  onChange: (
    configuration: IFeedConfiguration,
    isDesignUpdate?: boolean
  ) => void;
}

const CategoryButton: React.FC<ICategoryButtonProps> = ({ configuration, onChange }) => {
  const [switchButtonState, setSwitchButtonState] = useState<string>(
    configuration.css?.categoryButton ? 'CSS' : 'HAND'
  );
  const onChangeCssParam = (value: string) => {
    const css = configuration.css ?? {};
    css.categoryButton = value;
    onChange({ ...configuration, css });
  };

  return (
    <>
      <section className="feed-editor-appearance__section">
        <FormItem
          title="Настройка кнопок категорий"
          overlayClassName="feed-editor-appearance__tooltip"
          className="feed-editor-appearance__font"
        >
          <SwitchButton
            buttons={cssSwitchButtons}
            activeKey={switchButtonState}
            onClick={setSwitchButtonState}
          />
        </FormItem>
        {switchButtonState === 'CSS' && (
          <ParamCss
            title={'Кнопки категорий'}
            onChangeCssParam={onChangeCssParam}
            value={
              configuration.css?.categoryButton ??
              currentCategoryButtonTextCssParam(configuration)
            }
          />
        )}
      </section>
      {switchButtonState === 'HAND' && (
        <HandCategoryButtonParams
          isActive={switchButtonState === 'HAND'}
          configuration={configuration}
          onChange={onChange}
          onChangeCssParam={onChangeCssParam}
        />
      )}
    </>
  );
};

export default CategoryButton;
